<template>
  <v-card color="elevation-0">
    <main-menu :drawer="showMenu" @changeValue="updateDrawer" />

    <v-toolbar class="elevation-0 main-toolbar" height="50px" fixed app color="primary" :clipped-right="true">
      <v-toolbar-side-icon class="hidden-lg-and-up" dark @click.stop="toggleMenu"></v-toolbar-side-icon>

      <companies-list />
      <v-spacer />

      <v-btn title="Sair" depressed color="transparent" class="mb-0" @click="logout">
        <span class="white--text">Sair</span>
        <v-icon color="white" class="ml-1" dark>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content class="main">
      <v-layout justify-center class="layout-main">
        <transition name="fade" mode="out-in" appear>
          <router-view />
          <router-view name="modal" />
        </transition>
      </v-layout>
    </v-content>

  </v-card>
</template>

<script>
  import MainMenu from '@/components/MainMenu'
  import CompaniesList from '@/components/CompaniesList'
  import { mapGetters } from 'vuex'

  export default {
    name: 'AppLogged',
    components: {
      MainMenu,
      CompaniesList
    },
    data () {
      return {
        showMenu: true
      }
    },
    computed: {
      ...mapGetters({
        isAuthenticated: 'global/isAuthenticated'
      })
    },
    methods: {
      toggleMenu () {
        this.showMenu = !this.showMenu
      },
      updateDrawer (value) {
        this.showMenu = value
      },
      logout () {
        this.$store.dispatch('global/userLogout')
      }
    }
  }
</script>

<style lang="sass">
  @import '../assets/style/global'
</style>
